import { NurseFullRole } from "../../utils/models";

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] as const;
const DAY_PARTS = ["morning", "evening"] as const;

export const areRolesMatch = (role1: NurseFullRole, role2: NurseFullRole): boolean => {
	if (role1 === role2) {
		return true;
	}

	if (role1 === NurseFullRole.RN) {
		return role2 === NurseFullRole.LPN || role2 === NurseFullRole.LVN;
	}
	if (role2 === NurseFullRole.RN) {
		return role1 === NurseFullRole.LPN || role1 === NurseFullRole.LVN;
	}

	return false;
};

export function indexToDay(index: number | undefined): (typeof DAY_NAMES)[number] {
	return DAY_NAMES[index ?? 6] || DAY_NAMES[6];
}

export function indexToDayPart(index: number | undefined): (typeof DAY_PARTS)[number] {
	return DAY_PARTS[index ?? 1] || DAY_PARTS[1];
}

export const normalizeMessage = (msg: string | null | undefined): string | null => {
	return msg === "" || msg == null || msg === undefined ? null : msg;
};

export const compareMessages = (editMessage: string, nurseMessage: string | undefined): boolean => {
	// Convert empty values (null, undefined, '') to null for comparison
	return normalizeMessage(editMessage) !== normalizeMessage(nurseMessage);
};
